// extracted by mini-css-extract-plugin
module.exports = {"filter":"a10a3f92e9--filter--20sWI","filter-title":"a10a3f92e9--filter-title--1NKl9"};